"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customizeFilters = exports.buildDateFilterQuery = exports.buildQueryFromCategory = exports.createTicketPriceFilter = exports.createGameTagsFilters = exports.createGameTypeFilter = exports.filters = void 0;
var _ = __importStar(require("lodash"));
var TimeUtil_1 = require("../../utils/TimeUtil");
var GameStatus = {
    type: 'date',
    order: -3,
    header: 'game.filter.status.label',
    key: 'GameStatus',
    value: 'gameStatus',
    selectionType: 'multi_select',
    filters: [
        {
            order: 3,
            isSelected: false,
            name: 'game.filter.status.upcoming',
            value: 'upcoming',
            dateFilterType: 'upcoming'
        },
        {
            order: 0,
            isSelected: false,
            name: 'game.filter.status.active',
            value: 'active',
            dateFilterType: 'active'
        },
        {
            order: 2,
            isSelected: false,
            name: 'game.filter.status.new',
            value: 'new',
            dateFilterType: 'new'
        },
        {
            order: 1,
            isSelected: false,
            name: 'game.filter.status.endingSoon',
            value: 'endingSoon',
            dateFilterType: 'endingSoon'
        },
        {
            order: 4,
            isSelected: false,
            name: 'game.filter.status.ended',
            value: 'ended',
            dateFilterType: 'ended'
        }
    ]
};
var GameType = {
    type: 'type',
    order: -4,
    header: 'game.filter.gameTypeId.label',
    key: 'GameType',
    value: 'gameTypeId',
    selectionType: 'single_select',
    filters: [
        {
            order: 0,
            isSelected: false,
            name: 'game.filter.gameTypeId.instant',
            value: '1'
        },
        {
            order: 1,
            isSelected: false,
            name: 'game.filter.gameTypeId.fastplay',
            value: '5'
        },
        {
            order: 2,
            isSelected: false,
            name: 'game.filter.gameTypeId.draw',
            value: '2'
        },
        {
            order: 3,
            isSelected: false,
            name: 'game.filter.gameTypeId.interactive',
            value: '3'
        },
        {
            order: 4,
            isSelected: false,
            name: 'game.filter.gameTypeId.eInstant',
            value: '4'
        },
        {
            order: 5,
            isSelected: false,
            name: 'game.filter.gameTypeId.quickdraw',
            value: '7'
        }
    ]
};
var TopPrize = {
    type: 'topprize',
    order: -2,
    header: 'game.filter.topPrize.label',
    key: 'TopPrize',
    value: 'queryTopPrize',
    selectionType: 'multi_select',
    filters: [
        {
            order: 0,
            isSelected: false,
            name: 'game.filter.topPrize.f1000000',
            value: 'f1000000'
        },
        {
            order: 1,
            isSelected: false,
            name: 'game.filter.topPrize.f500000',
            value: 'f500000'
        },
        {
            order: 2,
            isSelected: false,
            name: 'game.filter.topPrize.f250000-t500000',
            value: 'f250000-t500000'
        },
        {
            order: 3,
            isSelected: false,
            name: 'game.filter.topPrize.f100000-t250000',
            value: 'f100000-t250000'
        },
        {
            order: 4,
            isSelected: false,
            name: 'game.filter.topPrize.f50000-t100000',
            value: 'f50000-t100000'
        },
        {
            order: 5,
            isSelected: false,
            name: 'game.filter.topPrize.f5000-t50000',
            value: 'f5000-t50000'
        },
        {
            order: 6,
            isSelected: false,
            name: 'game.filter.topPrize.t5000',
            value: 't5000'
        },
        {
            order: 7,
            isSelected: false,
            name: 'game.filter.topPrize.other',
            value: 'other'
        }
    ]
};
var createGameTypeFilter = function (gameTypes) { return ({
    type: 'type',
    order: 0,
    header: 'game.filter.gameTypeId.label',
    key: 'GameType',
    value: 'gameTypeId',
    selectionType: 'multi_select',
    filters: gameTypes.map(function (x) { return ({
        name: x.name,
        value: x.id,
        isSelected: false,
        order: x.id
    }); })
}); };
exports.createGameTypeFilter = createGameTypeFilter;
var createGameTagsFilters = function (gameTagTypes, gameTags) {
    return _.reduce(gameTagTypes, function (result, gameTagType) {
        var _a;
        var _filters = gameTags
            .filter(function (x) { return x.gameTagTypeId === gameTagType.id; })
            .map(function (x) { return ({
            name: x.name,
            value: x.id,
            isSelected: false,
            order: x.id
        }); });
        var key = gameTagType.name.replace(' ', '');
        var gameTagCategory = {
            type: 'tag',
            order: gameTagType.id,
            header: gameTagType.name,
            key: key,
            value: "query" + gameTagType.name
                .split(' ')
                .map(function (x) { return _.startCase(x.toLowerCase()); })
                .join(''),
            selectionType: 'multi_select',
            filters: _filters
        };
        return __assign(__assign({}, result), (_a = {}, _a[key] = gameTagCategory, _a));
    }, {});
};
exports.createGameTagsFilters = createGameTagsFilters;
var createTicketPriceFilter = function (gameRetailerPrices) { return ({
    type: 'price',
    order: -1,
    header: 'game.filter.retailPrice.label',
    key: 'TicketPrice',
    value: 'retailPrice',
    selectionType: 'multi_select',
    filters: gameRetailerPrices
        .filter(function (x) { return x > 0; })
        .map(function (x) { return ({
        name: x.toCurrencyFormat(),
        value: x,
        isSelected: false,
        order: x
    }); })
}); };
exports.createTicketPriceFilter = createTicketPriceFilter;
var buildDateFilterQuery = function (_filters, newGamePeriod, upcomingGamePeriod) {
    var query = [];
    _filters.forEach(function (filter) {
        if (filter.isSelected) {
            switch (filter.dateFilterType) {
                default:
                case 'new':
                    var period = TimeUtil_1.nowUtc().subtract(newGamePeriod, 'days');
                    query.push("playBegin.greaterOrEqualThan=" + period.toISOString() + "&playBegin.lessOrEqualThan=" + TimeUtil_1.nowUtc().toISOString());
                    break;
                case 'active':
                    query.push("playBegin.lessOrEqualThan=" + TimeUtil_1.nowUtc().toISOString() + "&active.equals=true");
                    break;
                case 'upcoming':
                    var upcomingCutoff = TimeUtil_1.nowUtc().add(upcomingGamePeriod, 'days');
                    query.push("playBegin.greaterOrEqualThan=" + TimeUtil_1.nowUtc().toISOString() + "&playBegin.lessOrEqualThan=" + upcomingCutoff.toISOString());
                    break;
                case 'endingSoon':
                    var endingCutoff = TimeUtil_1.nowUtc().add(upcomingGamePeriod, 'days');
                    query.push("playEnd.lessOrEqualThan=" + endingCutoff.toISOString() + "&playEnd.greaterOrEqualThan=" + TimeUtil_1.nowUtc().toISOString());
                    break;
                case 'ended':
                    query.push("playEnd.lessOrEqualThan=" + TimeUtil_1.nowUtc().toISOString());
                    break;
            }
        }
    });
    return query.length > 1 ? ["query=" + query.join(',').replace(/&/g, ' ')] : query;
};
exports.buildDateFilterQuery = buildDateFilterQuery;
var buildQueryFromCategory = function (filterCategory, newGamePeriod, upcomingGamePeriod) {
    if (filterCategory.type === 'date') {
        return buildDateFilterQuery(_.filter(filterCategory.filters, function (filter) { return filter.isSelected; }), newGamePeriod, upcomingGamePeriod);
    }
    var query = [];
    var selectedFilters = _.filter(filterCategory.filters, function (filter) { return filter.isSelected; });
    if (selectedFilters && selectedFilters.length > 0) {
        var queryStr = _.map(selectedFilters, function (_a) {
            var value = _a.value;
            return value;
        }).join(',');
        switch (filterCategory.type) {
            case 'topprize':
            case 'tag':
                queryStr = filterCategory.value + "=" + queryStr;
                break;
            case 'type':
            case 'price':
                queryStr = filterCategory.value + ".in=" + queryStr;
                break;
            default:
                break;
        }
        if (queryStr) {
            query.push(queryStr);
        }
    }
    return query;
};
exports.buildQueryFromCategory = buildQueryFromCategory;
var customizeFilters = function (filtersToCustomize, gameStatuses, topPrizes, gameTypes, isGameTypeMultiSelect) {
    var customize = function (filterCategory, filterValues, isMultiSelect) {
        if (!filterValues) {
            return filterCategory;
        }
        if (filterCategory.filters) {
            filterCategory.filters = filterCategory.filters
                .filter(function (filter) { return filterValues.includes(filter.value); })
                .sort(function (x, y) { return filterValues.indexOf(x.value) - filterValues.indexOf(y.value); });
        }
        if (!!isMultiSelect) {
            filterCategory.selectionType = 'multi_select';
        }
        return filterCategory;
    };
    return __assign(__assign({}, filtersToCustomize), { GameType: customize(filtersToCustomize.GameType, gameTypes, isGameTypeMultiSelect), GameStatus: customize(filtersToCustomize.GameStatus, gameStatuses), TopPrize: customize(filtersToCustomize.TopPrize, topPrizes) });
};
exports.customizeFilters = customizeFilters;
var filters = {
    GameStatus: GameStatus,
    TopPrize: TopPrize,
    GameType: GameType
};
exports.filters = filters;
//# sourceMappingURL=filters.js.map